
import { TableHead, TableHeader, TableRow } from '@/components/ui/table';

export function TeacherReportTableHeader() {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>วันที่สอน</TableHead>
        <TableHead>ประเภทการสอน</TableHead>
        <TableHead>Tier</TableHead>
        <TableHead>ระดับชั้น</TableHead>
        <TableHead>ชื่อนักเรียน</TableHead>
        <TableHead className="text-center">ส่งรายงานล่าช้า</TableHead>
        <TableHead className="text-center">ชีท</TableHead>
        <TableHead className="text-center">ลากะทันหัน</TableHead>
        <TableHead className="text-right">ชั่วโมง</TableHead>
        <TableHead className="text-right">รายได้ (บาท)</TableHead>
      </TableRow>
    </TableHeader>
  );
}
